jQuery(document).ready(function($) {
  if ($('.blog-posts-wrapper').length > 0) {
    var mixer = mixitup('.blog-posts-wrapper', {
      pagination: {
        limit: 4,
      },
    })
    $('#category-filter').change(function() {
      var selected = $(this)
        .find(':selected')
        .data('filter')
      mixer.filter(selected)
    })
  }
})
